//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FaceModal',
  data: function data() {
    return {
      title: '人脸识别详细',
      visible: false,
      model: {},
      confirmLoading: false,
      url: {
        imgerver: window._CONFIG['imgDomainURL']
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  created: function created() {},
  methods: {
    detail: function detail(params) {
      this.model = params;
      this.visible = true;
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    getAvatarView: function getAvatarView(srcId) {
      return this.url.imgerver + '/' + srcId;
    }
  }
};